
<div v-loading="loading" class="img-async">
  <img class="img-fluid" :src="src" :alt="alt" @load="load" @error="error">
</div>
